import React, { useContext } from 'react';

import { markErrorAsHandled } from '@confluence/graphql';
import { getMonitoringClient } from '@confluence/monitoring';
import { Attribution } from '@confluence/error-boundary';
import { DATABASE_EXPERIENCE, ExperienceTrackerContext } from '@confluence/experience-tracker';

import type { ContentPrerequisitesProps } from './ContentPrerequisites';
import { ContentPrerequisites } from './ContentPrerequisites';

type DatabasePrerequisitesProps = Pick<
	ContentPrerequisitesProps,
	'children' | 'contentQueryResult' | 'route'
>;

export const DatabasePrerequisites = ({
	children,
	contentQueryResult,
	route,
}: DatabasePrerequisitesProps) => {
	const experienceTracker = useContext(ExperienceTrackerContext);

	const handleUnexpectedError = (error: Error) => {
		experienceTracker.fail({
			name: DATABASE_EXPERIENCE,
			error,
		});
		getMonitoringClient().submitError(error, {
			attribution: Attribution.CONTENT_TYPES,
		});
		markErrorAsHandled(error);
	};

	return (
		<ContentPrerequisites
			route={route}
			contentQueryResult={contentQueryResult}
			passThroughOnLoading
			handleUnexpectedError={handleUnexpectedError}
		>
			{children}
		</ContentPrerequisites>
	);
};
